import {ChangeDetectionStrategy, Component, ElementRef, ViewChild} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {select, Store} from '@ngrx/store';
import {selectLoadedAssets} from '@appstore/app.reducer';
import {DEVELOPMENT_SKILLS, FRAMEWORK_SKILLS, TOOLS_SKILLS} from '@applications/welcome/data/skills';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone';
import {faMailBulk} from '@fortawesome/free-solid-svg-icons/faMailBulk';

@Component({
  selector: 'app-welcome',
  template: `
    <div class="app-welcome">
      <div class="app-welcome-left">
        <h3>Pages</h3>
        <ul>
          <li class="intro-anchor active"
              (click)="scrollTo('intro')">⚫ Intro
          </li>
          <li class="story-anchor"
              (click)="scrollTo('story')">⚫ What I Do
          </li>
          
          <li class="more-anchor"
              (click)="scrollTo('more')">⚫ Links
          </li>
        </ul>
        <app-link id="downloadCV"
                  [icon]="faDownload"
                  [link]="'https://xfallen.bandcamp.com/album/ep-super-position'">
          Download My EP
        </app-link>
      </div>
      <div class="app-welcome-right"
           (scroll)="onScroll($event)"
           #welcomeRight>
        <app-tooltip>[Super Position EP]
		<app-link [link]="'https://linktr.ee/ProdByFallen'">Streaming Everywhere!
        </app-link></app-tooltip>
        <div id="intro">
          <h1>∵/ProdByFallen</h1>
          <span id="text1">
            <b>Super Position EP</b>, featuring Archaeologist!<br><br>
			<div id="content">
    <iframe style="border: 0; width: 400px; height: 704px;" src="https://bandcamp.com/EmbeddedPlayer/album=3961355414/size=large/bgcol=333333/linkcol=2ebd35/tracklist=true/transparent=true/" seamless><a href="https://xfallen.bandcamp.com/album/ep-super-position">[EP] Super Position by ProdByFallen</a></iframe>
</div>
           
          </span>
          <app-link 
                    [link]="'https://linktr.ee/ProdByFallen'">https://linktr.ee/ProdByFallen
          </app-link>
        </div>
        <div id="story">
          <h2>What I Do</h2>
          
          <span id="text2">
           
            I make music, and sometimes I do chiptune remixes on <b>YouTube</b>
            <br><br>
            <app-link [link]="'https://Youtube.com/xFallenDemon99x'">xFallenDemon99x</app-link> (my main channel)<br>
            
          </span>
        </div>
        <div id="more">
          <h2>Links</h2>
          <div class="more-links">
            <app-link [link]="'https://linktr.ee/ProdByFallen'">Linktr.ee</app-link>
            <app-link [link]="'https://www.youtube.com/xFallenDemon99x'">YouTube</app-link>
            <app-link [link]="'https://xFallen.bandcamp.com'">Bandcamp</app-link>
            <app-link [link]="'https://open.spotify.com/artist/58I7icWChtlsIQI7mgmfYz'">Spotify</app-link>
            <app-link [link]="'https://music.apple.com/us/artist/prodbyfallen/1577865911'">iTunes
            </app-link>
			<app-link [link]="'https://soundcloud.com/Prod-By-Fallen'">SoundCloud</app-link>
			<app-link [link]="'https://xFallenDemon99x.itch.io'">itch.io</app-link>            
            <app-link [link]="'https://twitter.com/xFD99x'">Twitter</app-link>
            <app-link [link]="'https://facebook.com/ProdByFallen'">Facebook</app-link>
            <app-link [link]="'https://linktr.ee/TribalRose'">TribalRose</app-link>
			<app-link [icon]="faMail"
                    [link]="'mailto:TribalRoseBand@gmail.com'">Email</app-link>
            <app-link id="downloadCV"
                      [icon]="faDownload"
                      [link]="'https://xFallen.bandcamp.com/album/ep-super-position'">
              Download My EP
            </app-link>
			
        <app-tooltip>This website uses NicolaLC's Code (https://github.com/NicolaLC/nica-os)
		Support the Dev!</app-tooltip>
          </div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WelcomeComponent {
  public data: any;
  loadedAssets$ = this.store$.pipe(select(selectLoadedAssets));

  isIntroVisible = true;
  isEducationVisible = false;
  isWorkVisible = false;

  faDownload = faDownload;
  faPhone = faPhone;
  faMail = faMailBulk;
  DEVELOPMENT_SKILLS = DEVELOPMENT_SKILLS;
  FRAMEWORK_SKILLS = FRAMEWORK_SKILLS;
  TOOLS_SKILLS = TOOLS_SKILLS;

  ids = ['intro', 'story', 'education', 'works', 'skills', 'more'];

  @ViewChild('welcomeRight', {static: true}) welcomeRight: ElementRef;
  private scrollTimeout: any;

  constructor(private store$: Store<any>) {}

  scrollTo(elementId) {
    this.welcomeRight.nativeElement.querySelector(`#${ elementId }`).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  trackByFn(it, i) { return i; }

  onScroll($event: Event) {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.afterScroll(($event.target as any).scrollTop);
    }, 100);
  }

  afterScroll(scrollTop: number) {
    this.ids.forEach(id => {
      const element = document.querySelector(`#${ id }`) as any;
      if ( !element ) {
        return;
      }
      if ( scrollTop >= element.offsetTop - 500 ) {
        document.querySelector(`.${ id }-anchor`).classList.add('active');
      } else {
        document.querySelector(`.${ id }-anchor`).classList.remove('active');
      }
    });
  }
}
